var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay",attrs:{"id":"popup1"}},[_c('div',{staticClass:"popup"},[_c('h2',[_vm._v("Hey, Time's Up!")]),_c('a',{staticClass:"close",on:{"click":_vm.closeOverlay}},[_vm._v("×")])])])}
var staticRenderFns = []

export { render, staticRenderFns }